export default "__VITE_ASSET__DZoGNGpv__"